<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='用户ID'>
                <GridSelect
                    title='选择用户'
                    labelName='userName'
                    labelValue='id'
                    :value='queryForm.userId'
                    :limit='1'
                    style='width: 200px'
                    size='small'
                    placeholder='请选择用户'
                    @getValue='getValue'
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl='/mpp/user/findList'
                    entityBeanName='mppUser'
                    queryEntityUrl='/mpp/user/get'
                >
                </GridSelect>
            </el-form-item>
            <el-form-item label='签到日期'>
                <el-input v-model='queryForm.signDate' style='width: 200px'></el-input>
            </el-form-item>
            <el-form-item label='连续天数'>
                <el-input v-model='queryForm.continuous' style='width: 200px'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMarketSignList'>查询</el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
<!--                    <el-button-->
<!--                        type='primary'-->
<!--                        size='small'-->
<!--                        icon='el-icon-plus'-->
<!--                        @click='addMarketSign'-->
<!--                    >新建-->
<!--                    </el-button>-->
<!--                    <el-button-->
<!--                        type='warning'-->
<!--                        plain-->
<!--                        size='small'-->
<!--                        icon='el-icon-edit'-->
<!--                        :disabled='multipleSelection.length != 1'-->
<!--                        @click='editMarketSign(null)'-->
<!--                    >修改-->
<!--                    </el-button>-->
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMarketSign(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
                      <Icon color='#606266'>
                        <Search />
                      </Icon>
                    </span>
<!--                    <span-->
<!--                        title='下载模板'-->
<!--                        class='icon-box'-->
<!--                        @click='importTemplate'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowDown />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class='icon-box'-->
<!--                        title='导入数据'-->
<!--                        @click='isImport'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowExportUp24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        title='导出数据'-->
<!--                        class='icon-box'-->
<!--                        @click='exportMarketSignList'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowDownload24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMarketSignList'
                    >
                      <Icon color='#606266'>
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='marketSignList'
                row-key='id'
                border
                height='100%'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='userId'
                    label='用户'
                    width='300'
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                            <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='signDate'
                    label='签到日期'
                    width='300'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='continuous'
                    label='连续天数'
                    width='300'
                ></el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='checkMarketSign(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
<!--                            <div @click='editMarketSign(scop.row.id)'>-->
<!--                                <Icon size='16'>-->
<!--                                    <Edit24Regular />-->
<!--                                </Icon>-->
<!--                                <span class='operation-label'>修改</span>-->
<!--                            </div>-->
                            <div @click='deleteMarketSign(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='marketSignStates[marketSignState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='marketSign'
                        ref='marketSignForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <el-form-item
                            label='用户'
                            prop='userId'
                        >
                            <GridSelect
                                title='选择用户'
                                labelName='userName'
                                labelValue='id'
                                :value='marketSign.userId'
                                :disabled="marketSignState == 'check'"
                                :limit='1'
                                style='width: 200px'
                                size='small'
                                placeholder='请选择用户'
                                @getValue='getValueForm'
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl='/mpp/user/findList'
                                entityBeanName='mppUser'
                                queryEntityUrl='/mpp/user/get'
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item
                            label='签到日期'
                            prop='signDate'
                        >
                            <el-input
                                size='small'
                                v-model='marketSign.signDate'
                                style='width: 200px'
                                :disabled="marketSignState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='连续天数'
                            prop='continuous'
                        >
                            <el-input
                                size='small'
                                v-model='marketSign.continuous'
                                style='width: 200px'
                                :disabled="marketSignState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="marketSignState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
export default {
    components: {
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMarketSignList();
                this.getMarketSignList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMarketSignList();
                this.getMarketSignList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            queryForm: {
                userId: '', //用户ID
                signDate: '', //签到日期
                continuous: '', //连续天数
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            marketSignState: 'add',
            marketSignStates: {
                add: '新建签到记录',
                check: '查看签到记录',
                edit: '修改签到记录'
            },

            multipleSelection: [],
            marketSignList: [],
            marketSign: {
                userId: '', //用户ID
                signDate: '', //签到日期
                continuous: '', //连续天数
            },
            btnLoading: false,

            rules: {
                userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                signDate: [{ required: true, message: '签到日期不能为空', trigger: 'blur' }],
                continuous: [{ required: true, message: '连续天数不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMarketSignList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMarketSignList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.marketSignList = [];
        },
        resetDialog() {
            this.marketSignState = 'add';
            this.showDialog = false;
            this.queryForm = {
                userId: '', //用户ID
                signDate: '', //签到日期
                continuous: '', //连续天数
            };
            this.getMarketSignList();
        },
        closeDialog() {
            this.showDialog = false;
            this.marketSign = {
                userId: '', //用户ID
                signDate: '', //签到日期
                continuous: '', //连续天数
            };
        },
        submitForm() {
            if (this.marketSignState == 'add') {
                this.$refs.marketSignForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/sign/add`, { ...this.marketSign }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketSignList();
                                this.resetDialog();
                                this.getMarketSignList();
                            }
                        });
                    }
                });
            } else if (this.marketSignState == 'edit') {
                this.$refs.marketSignForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/sign/edit`, { ...this.marketSign }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketSignList();
                                this.resetDialog();
                                this.getMarketSignList();
                            }
                        });
                    }
                });
            }
        },
        addMarketSign() {
            this.showDialog = true;
            this.marketSignState = 'add';
        },
        checkMarketSign(marketSignId) {
            console.log(marketSignId);
            this.currentMarketSignId = marketSignId;

            this.getMarketSignById();
            this.showDialog = true;
            this.marketSignState = 'check';
        },
        editMarketSign(marketSignId) {
            console.log('marketSign', marketSignId);
            if (marketSignId) {
                this.currentMarketSignId = marketSignId;
                this.getMarketSignById();
            } else {
                this.marketSign = { ...this.marketSign, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.marketSignState = 'edit';
        },
        deleteMarketSign(marketSignId) {
            let ids = '';
            if (marketSignId) {
                ids = marketSignId;
            } else {
                ids = this.multipleSelection.map((marketSign) => marketSign.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/market/sign/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMarketSignList();
                            this.getMarketSignList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMarketSignList() {
            this.resetMarketSignList();
            this.getMarketSignList();
        },
        getMarketSignList(query = {}) {
            this.loading = true;
            get(`/market/sign/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.marketSignList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMarketSignById() {
            get(`/market/sign/get`, { id: this.currentMarketSignId }).then((res) => {
                if (res.success) {
                    this.marketSign = { ...this.marketSign, ...res.marketSign };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMarketSignList() {
            //this.btnLoading = true;
            exprotExcel(`/market/sign/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/market/sign/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/market/sign/importData`, formData);
            this.refreshMarketSignList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMarketSignList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMarketSignList();
        },
        getValue(value) {
            this.queryForm.userId = value;
        },
        getValueForm(value) {
            this.marketSign.userId = value;
        }
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>